import { LoginOutlined, RollbackOutlined, ContactsOutlined, CalendarOutlined, BarChartOutlined } from '@ant-design/icons';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import dashboard from './dashboard';
import pages from './page';

const extraIcons = {
  LoginOutlined,
  RollbackOutlined,
  ContactsOutlined,
  CalendarOutlined,
  BarChartOutlined,
  AccessTimeIcon
};

const isNotificationsRoute = () => {
  try {
    const path = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
    return path.startsWith('/notificaciones');
  } catch {
    return false;
  }
};

const isInformesRoute = () => {
  try {
    const path = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
    return path.startsWith('/areas/informes');
  } catch {
    return false;
  }
};

const resolveAreasUrl = () => {
  try {
    const path = typeof window !== 'undefined' ? window.location?.pathname || '' : '';
    if (path.startsWith('/i')) return '/areas/iberdrola';
    if (path.startsWith('/familias/')) return '/areas/gestion';
    if (path.startsWith('/areas/presupuestos')) return '/areas/presupuestos';
    if (path.startsWith('/areas/plan-estrategico')) return '/areas/plan-estrategico';
    if (path.startsWith('/areas/portal-usuario')) return '/areas/portal-usuario';
    if (path.startsWith('/areas/mantenimientos-periodicos')) return '/areas/mantenimientos-periodicos';
    if (path.startsWith('/areas/instrumentacion')) return '/areas/instrumentacion';
    if (path.startsWith('/operarios')) return '/areas';
  } catch {}
  try {
    const area = localStorage.getItem('current_area');
    if (area === 'i') return '/areas/iberdrola';
    if (area && area.startsWith('familia-')) return '/areas/gestion';
    if (area === 'presupuestos') return '/areas/presupuestos';
    if (area === 'plan-estrategico') return '/areas/plan-estrategico';
    if (area === 'portal-usuario') return '/areas/portal-usuario';
    if (area === 'mantenimientos-periodicos') return '/areas/mantenimientos-periodicos';
    if (area === 'instrumentacion') return '/areas/instrumentacion';
    if (area === 'operarios') return '/areas';
  } catch {}
  return '/areas';
};

const buildBaseNavigation = (prefix = 'nav') => [
  {
    id: `${prefix}-login`,
    title: 'Login',
    type: 'item',
    url: '/login',
    icon: extraIcons.LoginOutlined,
    target: true
  },
  {
    id: `${prefix}-areas`,
    title: 'Areas',
    type: 'item',
    get url() {
      return resolveAreasUrl();
    },
    icon: extraIcons.RollbackOutlined
  },
  {
    id: `${prefix}-contacts`,
    title: 'Contactos',
    type: 'item',
    url: '/areas/gestion/telefonos',
    icon: extraIcons.ContactsOutlined
  },
  {
    id: `${prefix}-agenda`,
    title: 'Agenda',
    type: 'item',
    url: '/areas/agenda/calendario',
    icon: extraIcons.CalendarOutlined,
    onClick: () => {
      try {
        localStorage.setItem('current_area', 'agenda');
      } catch {}
    }
  },
  {
    id: `${prefix}-mantenimientos`,
    title: 'Revisiones periódicas',
    type: 'item',
    url: '/areas/mantenimientos-periodicos/calendario',
    icon: extraIcons.AccessTimeIcon,
    onClick: () => {
      try {
        localStorage.setItem('current_area', 'mantenimientos-periodicos');
      } catch {}
    }
  },
  {
    id: `${prefix}-instrumentacion`,
    title: 'Instrumentación',
    type: 'item',
    url: '/areas/instrumentacion/calendario',
    icon: extraIcons.AccessTimeIcon,
    onClick: () => {
      try {
        localStorage.setItem('current_area', 'instrumentacion');
      } catch {}
    }
  }
];

const notificationsMenu = {
  id: 'notifications-navigation',
  title: 'Navigation',
  type: 'group',
  children: buildBaseNavigation('notifications')
};

const informesBaseNavigation = buildBaseNavigation('informes').map((item) =>
  item.id === 'informes-areas' ? { ...item, skipSelection: true } : item
);

const informesMenu = {
  id: 'informes-navigation',
  title: 'INFORMES',
  type: 'group',
  children: [
    {
      id: 'informes-presupuestos',
      title: 'Informes Presupuestos',
      type: 'item',
      url: '/areas/informes/presupuestos',
      icon: extraIcons.BarChartOutlined,
      activeUrls: ['/areas/informes', '/areas/informes/presupuestos']
    },
    {
      id: 'informes-desviacion',
      title: 'Informes Desviación Horas',
      type: 'item',
      url: '/areas/informes/desviacion-horas',
      icon: extraIcons.AccessTimeIcon
    },
    {
      id: 'informes-home',
      title: 'Informes',
      type: 'item',
      url: '/areas/informes/vrp-crm',
      icon: extraIcons.BarChartOutlined,
      exact: true
    },
    {
      id: 'informes-resumen-obras',
      title: 'Resumen de Obras',
      type: 'item',
      url: '/areas/informes/resumen-obras',
      icon: extraIcons.BarChartOutlined,
      exact: true
    },
    ...informesBaseNavigation
  ]
};

const menuItems = {
  get items() {
    if (isNotificationsRoute()) return [notificationsMenu];
    if (isInformesRoute()) return [informesMenu];
    return [dashboard, pages];
  }
};

export default menuItems;
